(() => {
  function initializeHeader() {
    const header = document.querySelector('[data-lc-header]');
    if (!header || header.dataset.lcReady) return;
    header.dataset.lcReady = 'true';
    const menuButton = header.querySelector('[data-lc-menu-toggle]');
    const navigation = header.querySelector('#lc-navigation');
    const searchButton = header.querySelector('[data-lc-search-toggle]');
    const search = header.querySelector('[data-lc-search]');
    const closeMenu = () => { navigation.removeAttribute('data-open'); menuButton.setAttribute('aria-expanded', 'false'); };
    const closeSearch = () => { search.removeAttribute('data-open'); searchButton.setAttribute('aria-expanded', 'false'); };
    menuButton.addEventListener('click', () => {
      const open = !navigation.hasAttribute('data-open');
      closeSearch();
      navigation.toggleAttribute('data-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
    });
    searchButton.addEventListener('click', () => {
      const open = !search.hasAttribute('data-open');
      closeMenu();
      search.toggleAttribute('data-open', open);
      searchButton.setAttribute('aria-expanded', String(open));
      if (open) search.querySelector('input[type="search"]').focus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (navigation.hasAttribute('data-open')) { closeMenu(); menuButton.focus(); }
      if (search.hasAttribute('data-open')) { closeSearch(); searchButton.focus(); }
    });
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) { closeMenu(); closeSearch(); } });
    document.addEventListener('lc:cart-open', () => { closeMenu(); closeSearch(); });
  }
  initializeHeader();
  document.addEventListener('shopify:section:load', initializeHeader);
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-lc-sort]')) event.target.form.requestSubmit();
  });
})();
